import React from 'react';

import Connect from './connect';
import Disconnect from './disconnect';
import Status from './status';

import type { Grant, Provider } from '../types';

export interface Props {
  grant?: Grant;
  paths: {
    auth: string;
    destroy: string;
  };
  provider: Provider;
  scopes?: string[];
}

export default function NylasGrant({ grant: grantProp, paths, provider, scopes }: Props) {
  const [grant, setGrant] = React.useState<Grant | undefined>(grantProp);

  let control;
  if (!grant || grant.expired) {
    control = (
      <Connect
        grant={grant}
        path={paths.auth}
        provider={provider}
        scopes={scopes}
      />
    );
  } else {
    control = (
      <Disconnect
        destroyPath={paths.destroy}
        onDestroy={() => setGrant(undefined)}
      />
    );
  }

  return (
    <div className="d-flex align-items-top gap-3">
      <img src={provider.icon} style={{ width: 24, height: 24 }} />

      <div className="flex-1">
        <h4 className="my-0">{provider.label}</h4>
        <Status grant={grant} />
      </div>

      <div>{control}</div>
    </div>
  );
}
